import { BenefitTypes } from '@strata/constants';
import { Button } from '@strata/react-buttons';
import { Form, Formik } from 'formik';

import { CapturedDataListener } from 'components/intakeForm/CapturedDataListener';
import { useInputFocusRef } from 'components/intakeForm/FormHelpers';
import { type IntakeFormSectionProps } from 'components/intakeForm/IntakeFormSectionProps';
import { ProductInputs } from 'components/intakeForm/ProductInputs';
import { DEFAULT_PHARMACY_PLACE_OF_SERVICE } from 'services/constants';
import { useAppDispatch, useAppSelector } from 'store';
import { FormSections, IntakeFormSectionSchemas } from 'store/intakeForm/intakeFormSchema';
import { updateCapturedData } from 'store/intakeForm/intakeFormSlice';
import { goToNextSection } from 'store/intakeForm/intakeFormThunks';

const Section = FormSections.PRODUCT;

export const Product = ({ isOpen }: IntakeFormSectionProps) => {
    const dispatch = useAppDispatch();
    const { activeSection, capturedData } = useAppSelector((state) => state.intakeForm);

    const benefitRef = useInputFocusRef(isOpen, activeSection, Section);

    return (
        <Formik
            initialValues={{
                ...capturedData[Section],
                benefit: capturedData[Section].benefit ?? BenefitTypes.PHARMACY,
                placeOfService:
                    capturedData[Section].placeOfService ?? DEFAULT_PHARMACY_PLACE_OF_SERVICE,
            }}
            enableReinitialize
            validateOnMount
            validationSchema={IntakeFormSectionSchemas[Section]}
            onSubmit={(values) => {
                dispatch(updateCapturedData({ [Section]: values }));
                dispatch(goToNextSection(Section));
            }}
        >
            {(formik) => (
                <Form className="sds_intake-form-section" style={{ maxWidth: '630px' }}>
                    <CapturedDataListener section={Section} isOpen={isOpen} />
                    <ProductInputs
                        segmentId={capturedData[FormSections.HEALTH_PLAN_AND_PATIENT].segmentId}
                        benefitRef={benefitRef}
                    />
                    <Button
                        intent={Button.Intent.PRIMARY}
                        id="product-continue-button"
                        label="Continue"
                        type="submit"
                        disabled={!formik.isValid}
                    />
                </Form>
            )}
        </Formik>
    );
};
